import { Dialog, DialogProps, Typography } from '@mui/material'
import {
  ContentContainer,
  FooterContainer,
} from './add-logo-settings-dialog.styles'
import DragAndDropField from '../fields/drag-and-drop-field/drag-and-drop-field.component'
import { useState } from 'react'
import AddLogoSettingsInstruction from './add-logo-settings-instructions/add-logo-settings-instructions.component'
import ActionButtons from '../action-buttons/action-buttons.component'
import { useUploadLogoMutation } from 'store/auth/auth.api'
import { getUserId } from 'utils/common'

interface AddLogoSettingsDialogProps extends DialogProps {
  handleClose: () => void
}

const AddLogoSettingsDialog = ({
  open,
  handleClose,
}: AddLogoSettingsDialogProps) => {
  const userId = getUserId()
  const [files, setFiles] = useState<FileList | null>(null)

  const [uploadLogo, { isError }] = useUploadLogoMutation()

  const handleUpload = async () => {
    try {
      if (files && files.length > 0) {
        await uploadLogo({ userId, file: files[0] }).unwrap()
        if (!isError) {
          handleClose()
        }
      }
    } catch (error) {
      console.error('Error uploading logo:', error)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <ContentContainer>
        <Typography mb={2}>
          Your logo will appear at the top of this site and on customer
          invoices.
        </Typography>
        <DragAndDropField files={files} setFiles={setFiles} />
        <AddLogoSettingsInstruction />
      </ContentContainer>
      <FooterContainer>
        <ActionButtons
          firstBtnProps={{
            title: 'Cancel',
            onClick: handleClose,
            bgcolor: 'secondary.main',
          }}
          secondBtnProps={{
            title: 'Save',
            bgcolor: 'primary.main',
            onClick: handleUpload,
          }}
        />
      </FooterContainer>
    </Dialog>
  )
}

export default AddLogoSettingsDialog
